import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PspBranchState } from '../reducers/base-psp-branch.reducer';

const getPspBranchState = createFeatureSelector<PspBranchState>('pspBranch');
export const getPspBranchList = createSelector(getPspBranchState, (state) => state.pspBranch);
export const getCurrentBranch = createSelector(getPspBranchState, (state) => state.currentBranch);
export const getBranchInactiveFilter = createSelector(getPspBranchState, (state) => state.branchFilter.filterActive);
